/** @typedef {import('./filterBar').FilterField} FilterField */

import React from 'react';

import { TestableSelect, TestableSelectItem } from '@components/general/TestableComponents';
import ClearableTextInput from '@components/general/ClearableTextInput';

import PropTypes from 'prop-types';

export default function FilterBarInput({ field, displayValue, textDisplayValue, onTextChange, onChange }) {
  const key = field.key;
  const value = displayValue ?? '';
  const textValue = textDisplayValue ?? value;

  if (field.type === 'text') {
    return (
      <ClearableTextInput
        dataTestId={`filter-${key}`}
        type="text"
        value={textValue}
        onChange={(e) => onTextChange(key, e.target.value)}
        className="border rounded w-full"
        placeholder={`Filter by ${field.label.toLowerCase()}...`}
      />
    );
  }

  if (field.type === 'date') {
    return (
      <input
        data-testid={`filter-${key}`}
        type="date"
        value={value}
        onChange={(e) => onChange(key, e.target.value)}
        className="border rounded w-full px-3 py-2"
      />
    );
  }

  return (
    <TestableSelect
      dataTestId={`filter-${key}`}
      value={value || 'All'}
      onChange={(v) => onChange(key, v)}
      className="border rounded w-full"
      disabled={field.options?.length === 0}
    >
      <TestableSelectItem dataTestId={`filter-${key}-all`} key={`${key}-all`} value="All">
        All
      </TestableSelectItem>

      {field.options?.map((option) => {
        const isObjectOption = typeof option === 'object' && option.value !== undefined;
        const optionValue = isObjectOption ? option.value : option;

        let optionLabel;

        if (isObjectOption) {
            optionLabel = option.label;
        } else {
            optionLabel = field.transform ? field.transform(option) : option;
        }

        return (
          <TestableSelectItem
            dataTestId={`filter-${key}-${optionValue}`}
            key={optionValue}
            value={optionValue}
          >
            {optionLabel}
          </TestableSelectItem>
        );
      })}
    </TestableSelect>
  );
}

FilterBarInput.propTypes = {
  field: PropTypes.object.isRequired,
  displayValue: PropTypes.string,
  textDisplayValue: PropTypes.string,
  onTextChange: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};